// src/services/helpers/ProtectedRoute.js
import React, { useEffect, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { isTokenExpired } from "../../components/utils/authHelpers";
import { useGetAdminStatusQuery } from "../admin/admin";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, logout } = useContext(AuthContext);
  const token = localStorage.getItem("token");
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const {
    data: adminStatus,
    error,
    isLoading: isAdminLoading,
  } = useGetAdminStatusQuery(undefined, {
    skip: !isAdminRoute || !isAuthenticated,
    // Add caching to prevent repeated calls
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (isAdminRoute && !isAdminLoading) {
      if (error || (adminStatus && !adminStatus.isAdmin)) {
        logout();
      }
    }
  }, [adminStatus, error, isAdminRoute, isAdminLoading, logout]);

  // Show loading only briefly during initial auth check
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!isAuthenticated || isTokenExpired(token)) {
    return <Navigate to="/login" replace />;
  }

  // Show loading indicator while checking admin status
  if (isAdminRoute && isAdminLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Verifying access...
      </div>
    );
  }

  if (isAdminRoute && adminStatus && !adminStatus.isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
